<template>
	<div class="ui-select-group">
		<label v-for="option in options">
			<input v-model="model" type="checkbox" :name="name" :value="option.value">
			{{ option.name }}
		</label>
	</div>
</template>

<script setup>
	import { ref, watch, watchEffect, defineEmits } from "vue"

	const props = defineProps({
		name: String,
		options: Array,
		modelValue: {
	      type: Object,
	      default: () => ([])
	    },
	})

	const model = ref(props.modelValue)

	const emit = defineEmits(['update:modelValue'])

	watchEffect(() => {
      emit('update:modelValue', model.value);
    });

    watch(() => model.value, (newModel) => {
      emit('update:modelValue', model.value);
    });
</script>

<style scoped>
	.ui-select-group {
		display: flex;
		gap: 4px;
	}

	.ui-select-group label {
		height: 52px;
    border: var(--form-field_border);
    border-radius: 10px;
    padding: 6px 16px;
    width: 100%;
    background: var(--form-field_background);
    font-size: 19px;
    color: var(--form-field_color);
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.76px;
    display: flex;
    align-items: center;
    cursor: pointer;
	}
</style>